import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { type PageLayoutStore } from 'shared/layout'
import { Campaign, type ICreateCampaignStep, type IResponseFullCampaign } from 'entities/Campaign'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type ContactsDetailsStore } from 'widgets/ContactsDetails'
import { CampaignRoutes } from 'pages/campaigns/types'

export class CampaignDetailStore {
  private readonly _campaign
  private _contactsDetailsStore: ContactsDetailsStore | null = null
  private _activeStep: ICreateCampaignStep | null = null

  constructor(
    response: IResponseFullCampaign,
    public pageLayoutStore: PageLayoutStore,
    private _entities: IEntitiesStore
  ) {
    const onSuccessDelete = () => {
      uiStore.changeRoute({
        path: `${CampaignRoutes.root}/${CampaignRoutes.all}`,
      })
    }

    this._campaign = new Campaign(response, onSuccessDelete, this._entities)
    makeAutoObservable(this)
  }

  get contactsDetailsStore() {
    return this._contactsDetailsStore
  }

  get campaign() {
    return this._campaign
  }

  get activeStep() {
    return this._activeStep
  }

  get entities() {
    return this._entities
  }

  setActiveStep = (activeStep: typeof this._activeStep) => {
    this._activeStep = activeStep
  }

  setContactsDetailsStore = (store: ContactsDetailsStore | null) => {
    this._contactsDetailsStore = store
  }
}
